import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IntubationService } from '../../intubation/services/intubation.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import * as actions from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setCuffFillOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const intubationService = new IntubationService(serviceId)
  try {
    const response: IOptionsResponse = yield call([intubationService, intubationService.getCuffFillOptions])
    const { entity } = response
    yield put(actions.setCuffFillOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setCuffFillOptions() error: ${e}`))
  }
}
export function* setCuffFillOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setCuffFillOptions)
}
